import React from 'react';
import ProfilePictureFrame from '../ProfilePictureFrame';

const ResumeBrandingWrapper = ({ resume, children, hidePhotoOverlay = false }) => {
  const bannerUrl = resume?.banner_url || '';
  const photoUrl = resume?.photo_url || '';
  const frameOption = resume?.profile_frame || '';
  const accentColor = resume?.highlight_color || '#3b82f6';

  return (
    <div className="resume-branding border rounded-lg overflow-hidden" style={{ borderColor: accentColor }}>
      {bannerUrl ? (
        <div
          className="resume-branding-banner h-28 bg-gray-100"
          style={{
            backgroundImage: `url(${bannerUrl})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
        />
      ) : null}
      <div className="resume-branding-body bg-white px-6 py-6">
        {!hidePhotoOverlay && photoUrl ? (
          <div className={bannerUrl ? '-mt-14 mb-4' : 'mb-4'}>
            <ProfilePictureFrame
              photoUrl={photoUrl}
              frameOption={frameOption}
              size="w-24 h-24"
            />
          </div>
        ) : null}
        {children}
      </div>
    </div>
  );
};

export default ResumeBrandingWrapper;
